import { Link } from "wouter";
import { Button } from "@/components/ui/button";
import { BrandText } from "@/components/brand-text";
import { ThemeToggle } from "@/components/theme-toggle";
import { LanguageToggle } from "@/components/language-toggle";
import { useLanguage } from "@/components/language-provider";
import { ArrowLeft } from "lucide-react";
import { WEBSITE_ROUTES } from "@/lib/config";

export function PageHeader({ showBack = true }: { showBack?: boolean }) {
  const { language } = useLanguage();

  const navLinks = [
    { href: WEBSITE_ROUTES.dynamics365, label: "Dynamics 365" },
    { href: WEBSITE_ROUTES.apiDocs, label: "API" },
    { href: WEBSITE_ROUTES.pricing, label: language === "pt" ? "Preços" : "Pricing" },
    { href: WEBSITE_ROUTES.help, label: language === "pt" ? "Ajuda" : "Help" },
    { href: WEBSITE_ROUTES.validate, label: language === "pt" ? "Validar documento" : "Validate document" },
  ];

  return (
    <header className="sticky top-0 z-50 bg-background/85 backdrop-blur-lg border-b">
      <div className="container mx-auto px-4 py-3">
        <div className="flex items-center justify-between">
          {/* Left: back + brand */}
          <div className="flex items-center gap-3 shrink-0">
            {showBack && (
              <Link href="/">
                <Button variant="ghost" size="sm" className="gap-1.5 rounded-full text-xs">
                  <ArrowLeft className="w-3.5 h-3.5" />{language === "pt" ? "Voltar" : "Back"}
                </Button>
              </Link>
            )}
            <Link href="/">
              <BrandText className="text-lg" />
            </Link>
          </div>

          {/* Center: nav links */}
          <nav className="hidden md:flex items-center gap-6 absolute left-1/2 -translate-x-1/2">
            {navLinks.map((link) => (
              <Link key={link.href} href={link.href} className="text-xs font-medium uppercase text-muted-foreground hover:text-foreground transition-colors">
                {link.label}
              </Link>
            ))}
          </nav>

          {/* Right: controls */}
          <div className="flex items-center gap-1 shrink-0">
            <LanguageToggle />
            <ThemeToggle />
          </div>
        </div>
      </div>
    </header>
  );
}
